var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DashboardHeader'),_c('transition',{attrs:{"name":"slide"}},[(_vm.MENU_ACTIVE)?_c('Menu'):_vm._e()],1),_c('transition',{attrs:{"name":"slide"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }